import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class PhoneField extends Component {
  constructor(props) {
    super(props)
    this.valueChange = this.valueChange.bind(this)
  }

  componentDidMount() {
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || ''
    this.props.setFormFieldValue(formType, fieldName, initialValue)
    this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
  }

  componentWillReceiveProps(nextProps) {
    const { formType, fieldName, defaultValue } = this.props
    if (defaultValue !== nextProps.defaultValue) {
      this.props.setFormFieldValue(formType, fieldName, nextProps.defaultValue)
      this.props.validateFormField(formType, fieldName, this.isValid(nextProps.defaultValue))
    }
  }

  valueChange(e) {
    e.preventDefault()
    const { formType, fieldName } = this.props
    const value = e.target.value.slice(0, 15)
    this.props.setFormFieldValue(formType, fieldName, value)
    this.props.validateFormField(formType, fieldName, this.isValid(value))
  }

  isValid(val) {
    return val !== '' && val.toString().length <= 15
  }

  render() {
    const {
      form,
      formType,
      fieldName,
      label,
      placeholder,
      additionalClass,
      showErrorLabel,
      isDisabled,
    } = this.props
    const showLabel = typeof showErrorLabel !== 'undefined' ? showErrorLabel : true
    return (
      <div className="field">
        <label htmlFor={fieldName} className="label">
          {label}
        </label>
        <div className="control">
          <input
            type="number"
            min={0}
            name={fieldName}
            value={form[formType][fieldName].value}
            className={`input ${additionalClass || ''}`}
            onChange={this.valueChange}
            placeholder={placeholder}
            disabled={isDisabled}
            id="phone"
          />
          {showLabel && <label className="label--error">Maximum 15 digits.</label>}
        </div>
      </div>
    )
  }
}

PhoneField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  additionalClass: PropTypes.string,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
  isDisabled: PropTypes.bool.isRequired,
  showErrorLabel: PropTypes.bool,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(PhoneField)
